export enum BlacklistChattingRole {
  ALL = "ALL",
  USER = "USER",
  PAID_USER = "PAID_USER",
  FREE_USER = "FREE_USER",
  NOT_MATCHED_USER = "NOT_MATCHED_USER",
  OTHER_PAID_USER = "OTHER_PAID_USER",
}
